import types  from "../types/types";
import { CategoriaLineaConvocatoria } from "../../models/ConvocatoriasModel/convocatoria.model";

interface initialState {
  idParticipante: number;
  categoria_linea_convocatoria: CategoriaLineaConvocatoria[];
  nombre_convocatoria: string;
  id_convocatoria_seleccionada: string;
  id_postulacion: number;
  tipo_participante: number;
  datos_postulacion: any;
}

const initialValues: initialState = {
  idParticipante: 0,
  categoria_linea_convocatoria: [],
  nombre_convocatoria: "",
  id_convocatoria_seleccionada: "",
  id_postulacion: 0,
  tipo_participante: 0,
  datos_postulacion: {}
};

export const participantesReducer = (state = initialValues, action: any) => {
  switch (action.type) {
    case types.idParticipante:
      return {
        ...state,
        idParticipante: action.payload.idParticipante,
      };
    case types.categoria_linea_convocatoria:
      return {
        ...state,
        categoria_linea_convocatoria: action.payload.categoria_linea_convocatoria,
      };
    case types.nombre_convocatoria:
      return {
        ...state,
        nombre_convocatoria: action.payload.nombre_convocatoria,
      };
      
    case types.id_convocatoria_seleccionada:
      return {
        ...state,
        nombre_convocatoria: action.payload.id_convocatoria_seleccionada,
      };
    case types.id_postulacion:
      return {
        ...state,
        id_postulacion: action.payload.id_postulacion,
      };
    case types.tipo_participante:
      return {
        ...state,
        tipo_participante: action.payload.tipo_participante,
      }
    case types.datos_postulacion:
      return {
        ...state,
        datos_postulacion: action.payload.datos_postulacion,
      }
    default:
      return state;
  }
};
